module.exports = __webpack_public_path__ + "materialdesignicons-webfont.svg?ae4dbede9d81a20c842b30332ab4e5b6";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mdi/font/fonts/materialdesignicons-webfont.svg?v=2.8.94
// module id = 1533
// module chunks = 0